import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { X, ExternalLink, AlertCircle } from 'lucide-react';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

const ManageSubscriptionModal = ({ isOpen, onClose, token }) => {
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const openPortal = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/v2/frugal/subscription/portal-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ return_url: window.location.origin + '/dashboard' })
      });
      const data = await res.json();
      if (res.ok && data.url) {
        window.location.href = data.url;
      } else {
        toast.error(data.detail || 'No se pudo abrir el portal. Contacta a soporte.');
        setLoading(false);
      }
    } catch {
      toast.error('Error de conexion');
      setLoading(false);
    }
  };

  const content = (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 p-4 overflow-y-auto">
      <div className="bg-slate-800 rounded-2xl w-full max-w-md my-4">
        <div className="flex items-center justify-between p-4 border-b border-slate-700">
          <h2 className="text-lg font-semibold text-white">Mi Suscripcion</h2>
          <button onClick={onClose} className="p-1.5 text-slate-400 hover:text-white" data-testid="manage-close-btn">
            <X size={20} />
          </button>
        </div>

        <div className="p-5 space-y-4">
          <p className="text-sm text-slate-300">
            Al abrir el portal podras:
          </p>
          <ul className="text-sm text-slate-200 space-y-2 pl-4">
            <li className="flex items-start gap-2"><span className="text-emerald-400">-</span> Cancelar tu suscripcion</li>
            <li className="flex items-start gap-2"><span className="text-emerald-400">-</span> Ver y descargar tus facturas</li>
            <li className="flex items-start gap-2"><span className="text-emerald-400">-</span> Actualizar tu metodo de pago</li>
            <li className="flex items-start gap-2"><span className="text-emerald-400">-</span> Actualizar tus datos de facturacion</li>
          </ul>

          <div className="p-3 bg-amber-500/10 border border-amber-500/30 rounded-lg flex gap-2">
            <AlertCircle className="w-4 h-4 text-amber-400 flex-shrink-0 mt-0.5" />
            <p className="text-xs text-amber-200">
              Seras redirigido a la pagina segura de Stripe. Al terminar, volveras automaticamente a tu dashboard.
            </p>
          </div>

          <button
            onClick={openPortal}
            disabled={loading}
            className="w-full py-3 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 text-white rounded-xl text-sm font-medium flex items-center justify-center gap-2"
            data-testid="open-portal-btn"
          >
            {loading ? 'Abriendo...' : <>Gestionar suscripcion <ExternalLink size={16} /></>}
          </button>

          <button
            onClick={onClose}
            className="w-full py-2.5 bg-slate-700 hover:bg-slate-600 text-white rounded-xl text-sm"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(content, document.body);
};

export default ManageSubscriptionModal;
